import React from 'react';
import { CircularProgress, Typography, Box } from '@mui/material';

/**
 * LoadingScreen - Full-screen or inline loading spinner with themed styling
 */
export default function LoadingScreen({ fullScreen = false, message = 'Loading...', size = 40 }) {
  if (fullScreen) {
    return (
      <div
        className="fixed inset-0 flex flex-col items-center justify-center z-50"
        style={{ background: 'var(--bg-primary)' }}
      >
        <div className="relative">
          {/* Glow effect behind spinner */}
          <div
            className="absolute inset-0 rounded-full animate-glow-pulse"
            style={{
              width: size + 20,
              height: size + 20,
              top: -10,
              left: -10,
            }}
          />
          <CircularProgress size={size} thickness={3} />
        </div>
        {message && (
          <Typography
            variant="body2"
            sx={{
              color: 'var(--text-secondary)',
              mt: 3,
              fontWeight: 500,
            }}
          >
            {message}
          </Typography>
        )}
      </div>
    );
  }

  return (
    <Box
      className="flex flex-col items-center justify-center py-12"
      sx={{ minHeight: 200 }}
    >
      <CircularProgress size={size} thickness={3} />
      {message && (
        <Typography
          variant="body2"
          sx={{ color: 'var(--text-secondary)', mt: 2, fontWeight: 500 }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
}
